import { BillPayFlowStep } from '../bill-pay-flow/bill-pay-flow';
import { ExternalPaymentFlowStep } from '../external-payment-flow/external-payment-flow';
import { InternalPaymentFlowStep } from '../internal-payment-flow/internal-payment-flow';

type GetXeroCardConfigArgs = {
  flowStep: ExternalPaymentFlowStep | InternalPaymentFlowStep | BillPayFlowStep;
  shouldDisplayCard: boolean;
};

export const getXeroCardConfig = ({ flowStep, shouldDisplayCard }: GetXeroCardConfigArgs) => {
  if (flowStep !== 'SUCCESS' || !shouldDisplayCard) {
    return {
      isCardVisible: false as const,
    };
  }

  return {
    isCardVisible: true as const,
  };
};
